import React from "react";
import { firestore } from '../firebase.js';
import ViewApplicantsModal from './ViewApplicantsModal';
import AssignJobCard from './AssignJobCard';
import '../Styles/Sass/AssignJob.scss';

function AssignJob(props) {
  const [userJobs, setUserJobs] = React.useState([]);
  const [isEmployer, setIsEmployer] = React.useState(true);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [modalJob, setModalJob] = React.useState({});
  const [pageNumber, setPageNumber] = React.useState(1);
  const [openFilter, setOpenFilter] = React.useState(false);
  const [filterCount, setFilterCount] = React.useState(0);

  React.useEffect(() => {
    getJobs();
    getUserJob();
    setPageNumber(1);
    setFilterCount(0);
  }, [props.openFilter]);

  function openModal(job) {
    setIsOpen(true);
    setModalJob(job);
  };

  function closeModal() {
    setIsOpen(false);
    setModalJob({});
  };

  const getUserJob = () => {
    if (props.user) {
      firestore.collection('users').doc(props.user.uid).get()
        .then(res => {
          let userData = res.data();
          if (userData.job !== 'employer') {
            setIsEmployer(false);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  const getJobs = () => {
    if (props.user) {
      firestore.collection('jobs').where('postedBy', '==', props.user.uid).get()
        .then(res => {
          let jobs = [];
          res.forEach(job => {
            if (props.openFilter === false) {
              jobs.push(job.data());
            } else if (props.openFilter === true) {
              if (job.data().takenBy === 'open') {
                jobs.push(job.data());
              }
            }
          });
          setUserJobs(jobs);
        })
        .catch(err => {
          console.log(err);
        })
    }
  }

  const renderJobs = () => {
    let currentPageJobs = [];
    for (let i = (6 * pageNumber - 6); i < (6 * pageNumber); i++) {
      if (userJobs[i]) {
        currentPageJobs.push(userJobs[i]);
      }
    };
    let renderedJobs = currentPageJobs.map(job => {
      return (
        <AssignJobCard
          key={job.jobId}
          job={job}
          takenBy={job.takenBy}
          openModal={openModal}
        />
      );
    });
    return renderedJobs;
  };

  const setFilter = (bool, int) => {
    setOpenFilter(bool);
    setFilterCount(int);
  }

  return(
    <section className='assignJob'>
      {
        isEmployer === true ?
          <>
            <ViewApplicantsModal
              modalIsOpen={modalIsOpen}
              closeModal={closeModal}
              job={modalJob}
              applicants={modalJob.applicants}
              user={props.user}
            />
            <h2>My Posted Jobs</h2>
            <button
              onClick={() => props.setOpenFilter(true)}
            >
              Only Show Open Jobs
            </button>
            <button
              onClick={() => props.setOpenFilter(false)}
            >
              Show All Jobs
            </button>
            <ul className='assignJob__list'>
              {renderJobs()}
            </ul>
            <div className='posts__pageBox'>
              <button
                className='posts__pageLink posts__pageLink--left'
                onClick={() => setPageNumber(pageNumber - 1)}
                disabled={pageNumber === 1}
              >
                &lt; Prev
              </button>
              <div className='posts__displayPage'>
                {
                  openFilter === false ?
                    `Page ${pageNumber} of ${Math.ceil(userJobs.length/6)}` :
                    `Page ${pageNumber} of ${Math.ceil((userJobs.length)/6)}`
                }
              </div>
              <button
                className='posts__pageLink posts__pageLink--right'
                onClick={() => setPageNumber(pageNumber + 1)}
                disabled={pageNumber === Math.ceil(userJobs.length/6)}
              >
                Next &gt;
              </button>
            </div>
          </> :
          <></>
      }
    </section>
  );
}

export default AssignJob;